<template>
  <card
    style="height: 33%;display: inline-block;"
    v-loading="loading"
    element-loading-background="rgba(0, 0, 0, 0.3)"
  >
    <div class="card-item solid">
      <div class="device-picker" style="right: auto;left: 20px;top: 12px;">
        土壤墒情
      </div>

      <div class="last-data">
        <div class="last-item" v-for="item in items" :key="item.key">
          <div class="v" :style="{ color: item.color }">{{ item.name }}</div>
          <div class="v">
            {{ last[item.key] || '-' }} {{ item.unit }}
          </div>
        </div>
      </div>

      <echart
        chartId="solid-qua"
        :options="options"
        :height="height - 76"
      ></echart>
    </div>
  </card>
</template>

<script>
import mixin from '../mixin'
import Echart from '@/components/Chart'
import Card from '../card'
import { list } from '@/service/meteorology'
import { subtract, add } from '@/utlis/date'
import sleep from '@/utlis/sleep'

export default {
  mixins: [mixin],
  components: { Echart, Card },
  props: { code: String },
  data() {
    return {
      loadingCols: false, // 初始化列数据
      loading: false,
      data: [],
      last: {},
      cols: [
        {
          key: 'soilt1',
          type: 'line',
          name: '土壤温度-1',
          color: '#fdc765',
          unit: '℃'
        },
        {
          key: 'soilh1',
          type: 'line',
          name: '土壤湿度-1',
          color: '#5ec9db',
          unit: '%RH',
          yIndex: 1
        },
        {
          key: 'soilt2',
          type: 'line',
          name: '土壤温度-2',
          color: '#82c36a',
          unit: '℃'
        },
        {
          key: 'soilt3',
          type: 'line',
          name: '土壤温度-3',
          color: '#009be9',
          unit: '℃'
        },
        {
          key: 'soilt4',
          type: 'line',
          name: '土壤温度-4',
          color: '#f27d51',
          unit: '℃'
        }
      ],
      timer: null
    }
  },
  beforeDestroy() {
    if (this.timer) {
      clearInterval(this.timer)
    }
  },
  computed: {
    dev() {
      return this.metes.find(m => m.id === this.deviceId)
    },
    deviceId() {
      if (this.code) {
        const dev = this.metes.find(m => m.key === this.code)
        return dev && dev.id
      } else {
        return ''
      }
    },
    items() {
      return this.cols.slice(0, 2)
    },
    options() {
      return {
        legend: { show: false },
        grid: {
          left: 44,
          right: 48,
          bottom: 12,
          containLabel: true
        },
        xAxis: {
          type: 'category',
          splitLine: { show: false }
        },
        yAxis: [
          {
            type: 'value',
            splitLine: { show: false }
          },
          {
            type: 'value',
            splitLine: { show: false }
          }
        ],
        tooltip: {
          transitionDuration: 0,
          formatter: params => {
            const date = params[0].value.date
            let htm = date
            params.forEach(
              ({ marker, dimensionNames, encode, seriesName, value }) => {
                htm += `</br> ${marker} ${seriesName}`
                const col = this.cols.find(c => c.name === seriesName)
                const unit = col ? col.unit : ''

                if (!value) {
                  htm += ': -'
                } else {
                  htm += `: ${value[dimensionNames[encode.y[0]]]} ${unit}`
                }
              }
            )
            return htm
          }
        },
        dataset: {
          dimensions: ['date'].concat(this.cols.map(c => c.key)),
          source: this.data
        },
        series: this.cols.map(k => ({
          type: k.type,
          name: k.name,
          yAxisIndex: k.yIndex || 0,
          color: k.color
        }))
      }
    }
  },
  mounted() {
    this.getData()

    this.timer = setInterval(() => {
      this.getData()
    }, 1000 * 60 * 10)
  },
  methods: {
    async getData() {
      if (!this.deviceId) return
      this.loading = true
      const [{ data }, { data: last }] = await Promise.all([
        list({
          companyId: this.companyId,
          deviceId: this.deviceId,
          begin: subtract(undefined, 1, 'days', 'YYYY-MM-DD 00:00:00'),
          end: add(undefined, 1, 'days', 'YYYY-MM-DD 00:00:00'),
          type: 'day'
        }),
        list({
          companyId: this.companyId,
          deviceId: this.deviceId,
          type: 'last'
        }),
        sleep(1)
      ])
      this.last = last
      this.data = data
      this.loading = false
    }
  },
  watch: {
    code() {
      this.getData()
    }
  }
}
</script>

<style lang="scss" scoped>
.device-picker {
  position: relative !important;
  left: 0 !important;
  top: 0 !important;
  padding-left: 20px;
  padding-top: 8px;
  box-sizing: border-box;
}
.no-data {
  height: 100%;
}

.last-data {
  margin-top: 12px;
  height: 32px;
  margin-left: 20px;
  margin-right: 20px;
  display: flex;
  flex-direction: row;
  align-items: center;
  border-bottom: 1px solid rgba(70, 103, 160, 0.9);
  border-top: 1px solid rgba(70, 103, 160, 0.9);
  box-sizing: border-box;
}
.last-item {
  flex: 1;
  display: flex;
  border-left: 1px solid rgba(70, 103, 160, 0.9);
  align-items: center;
  justify-content: center;
  &:last-child {
    border-right: 1px solid rgba(70, 103, 160, 0.9);
  }
  .v {
    display: inline-block;
    line-height: 32px;
    font-size: 1rem;
    &:first-child {
      margin-right: 8px;
    }
  }
}
</style>
